import { jsx as _jsx } from "react/jsx-runtime";
import { faCheckCircle, faInfoCircle, faWarning } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import toast from 'react-hot-toast';
import Icon from '@/components/Icon';
function NotificationIcon(param) {
    var _param_status = param.status, status = _param_status === void 0 ? 'info' : _param_status;
    if (status === 'error') {
        return /*#__PURE__*/ _jsx(Icon, {
            icon: faWarning
        });
    } else if (status === 'warning') {
        return /*#__PURE__*/ _jsx(Icon, {
            icon: faWarning
        });
    } else if (status === 'success') {
        return /*#__PURE__*/ _jsx(Icon, {
            icon: faCheckCircle
        });
    } else {
        return /*#__PURE__*/ _jsx(Icon, {
            icon: faInfoCircle
        });
    }
}
export default function useNotification() {
    return React.useCallback(function(message, options) {
        var _options_status, _options_icon;
        toast(message, {
            position: 'top-right',
            icon: (_options_icon = options === null || options === void 0 ? void 0 : options.icon) !== null && _options_icon !== void 0 ? _options_icon : /*#__PURE__*/ _jsx(NotificationIcon, {
                status: (_options_status = options === null || options === void 0 ? void 0 : options.status) !== null && _options_status !== void 0 ? _options_status : 'info'
            })
        });
    }, []);
}
